<template>
  <div class="editor-container">
    <nav class="nav-wrapper">
      <EditorToolBar />
    </nav>
    <div class="editor-wrapper">
      <aside class="page-container">
        <EditorPageBar />
      </aside>
      <main class="main-container">
        <EditorCanvas />
      </main>
      <aside class="element-container">
        <EditorPropertyBar />
      </aside>
    </div>

  </div>
</template>

<script setup lang="ts">
  import EditorToolBar from './components/EditorToolBar.vue';
  import EditorPageBar from './components/EditorPageBar.vue';
  import EditorCanvas from './components/EditorCanvas.vue';
  import EditorPropertyBar from './components/EditorPropertyBar.vue';
</script>

<style scoped>
  .editor-container {
    width: 100%;
    height: 100%;
    background-color: #dad2d2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .nav-wrapper {
    width: 100%;
    height: 60px;
    position: relative;
    z-index: 10;
  }

  .editor-wrapper {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .page-container {
    width: 180px;
    height: 100%;
    background-color: #fff;
    /* 右边阴影：x正偏移，阴影投向右侧 */
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);
    position: relative;
    z-index: 1;
  }

  .main-container {
    width: 0;
    flex: 1;
    height: 100%;
  }

  .element-container {
    width: 340px;
    height: 100%;
    background-color: #fff;
    /* 左边阴影：x负偏移，阴影投向左侧 */
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.08);
    position: relative;
    z-index: 1;
  }
</style>
